import ShModel from 'sh-www/models/sh-model';
import { attr, belongsTo } from '@ember-data/model';

export const TYPES = {
  DIRECT_ASSIGNMENT_DRAFT: 'direct_assignment_draft',
  COMPANY_JOIN_PROPOSAL: 'company_join_proposal',
};

const getJsonValue = (jsonData, key) => {
  if (!jsonData) return null;

  try {
    return JSON.parse(jsonData)?.[key] ?? null;
  } catch (error) {
    return null;
  }
}

class StashedRecord extends ShModel {
  @attr('string') uuid;
  @attr('string') jsonData;
  @attr('string') type;
  @attr('number') companyId;
  @attr('number') userId;

  @belongsTo('user', { async: false }) user;
  @belongsTo('company', { async: false}) company;

  /***************
    Values for COMPANY_JOIN_PROPOSAL
  ***************/
  
  get companyName() {
    return getJsonValue(this.jsonData, 'company_name');
  }

  get department() {
    return getJsonValue(this.jsonData, 'department');
  }

  get jobTitle() {
    return getJsonValue(this.jsonData, 'job_title');
  }

  /***************
    Values for DIRECT_ASSIGNMENT_DRAFT
  ***************/

  get sellerId() {
    return getJsonValue(this.jsonData, 'seller_id');
  }

  get title() {
    return getJsonValue(this.jsonData, 'title');
  }
}

export default StashedRecord;
